// Import the base German locale
const baseLocales = require('./locales.de.js').default;
// Import the German country translations
const countries = require('./countries.de.json');

// Create a deep copy of the base locales
const locales = JSON.parse(JSON.stringify(baseLocales));

// Add the common.countries section if it doesn't exist
if (!locales.common) {
    locales.common = {};
}
if (!locales.common.countries) {
    locales.common.countries = {};
}

// Add the country translations
Object.assign(locales.common.countries, countries);

export default locales;



// WEBPACK FOOTER //
// ./src/js/lang/locales.countries.de.js